import Typography from "@mui/material/Typography";
import { formatNumber } from "../../utils";

interface DiffAmountTextProps {
  /** ยอดโอน − ยอดต้องโอน. Null when nothing has been submitted to compare against. */
  diff: number | null;
}

/**
 * The one rendering of ผลต่าง, shared by every screen that shows it:
 *  - null      → "-" muted (0 − required would read as a full shortfall)
 *  - exactly 0 → "0.00" normal weight
 *  - negative  → โอนขาด, red (the case finance chases)
 *  - positive  → โอนเกิน, green, with an explicit "+" so the sign reads at a glance
 *
 * Takes the figure rather than the two operands because the branch-day summary is handed a
 * server-computed `diff_amount` over the whole branch-day, while a route row derives its own
 * from the pair it holds — both must land on the same colours and the same "+".
 */
export default function DiffAmountText({ diff }: DiffAmountTextProps) {
  if (diff === null) {
    return (
      <Typography component="span" variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  const isBalanced = diff === 0;
  const color = isBalanced
    ? "inherit"
    : diff < 0
      ? "error.main"
      : "success.main";

  return (
    <Typography
      component="span"
      variant="body2"
      sx={{ color, fontWeight: isBalanced ? 400 : 600, whiteSpace: "nowrap" }}
    >
      {diff > 0 ? `+${formatNumber(diff)}` : formatNumber(diff)}
    </Typography>
  );
}
